@let options = options$ | async;
@if (options) {
    <mat-select [(value)]="selectedObjectNumber" [disabled]="options.length < 2" (selectionChange)="onSelectionChange($event)">
        <mat-option *ngFor="let option of options" [value]="option">
            {{ option.description }}
        </mat-option>
    </mat-select>
}
